var map = {
	"./app-switcher.svg": 77702,
	"./circle.svg": 12469,
	"./download-white.svg": 95885,
	"./faux-profile.svg": 94093,
	"./hero-hexagon-mask.svg": 80599,
	"./icon-dashboard.svg": 89341,
	"./icon-data.svg": 87203,
	"./icon-donation-form.svg": 79660,
	"./icon-funnel.svg": 4343,
	"./icon-integrations.svg": 46194,
	"./logo-powered-by-qgiv.svg": 5525,
	"./no-mappings.svg": 73044,
	"./qgiv-bookmark-filled.svg": 32910,
	"./qgiv-bookmark.svg": 98453,
	"./qgiv-calendar-heart-circlebg.svg": 97488,
	"./qgiv-clock.svg": 23773,
	"./qgiv-confirmation.svg": 14658,
	"./qgiv-donation-grow.svg": 24145,
	"./qgiv-donation.svg": 99119,
	"./qgiv-filter.svg": 89199,
	"./qgiv-fire.svg": 61173,
	"./qgiv-fundraising-alt.svg": 90447,
	"./qgiv-fundraising.svg": 58949,
	"./qgiv-gift-add.svg": 9145,
	"./qgiv-gift-heart.svg": 69988,
	"./qgiv-impact.svg": 10875,
	"./qgiv-radio-button-active.svg": 44198,
	"./qgiv-radio-button.svg": 81863,
	"./qgiv-recurring.svg": 7806,
	"./qgiv-store-purchase.svg": 87148,
	"./qgiv-tag-solid.svg": 82321,
	"./redo.svg": 29433,
	"./support.svg": 5046,
	"./tickets-solid.svg": 15362,
	"./undo.svg": 69923
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 95899;